import { Controller } from "stimulus"

export default class extends Controller {
    openModal(event) {
        const url = event.currentTarget.getAttribute("data-url")
        const frame = document.querySelector('turbo-frame[id="allocations-modal"]')
        
        if (window.Turbo && Turbo.visit) {
            Turbo.visit(url, { frame: "allocations-modal" })
        } else if (frame) {
            fetch(url, {
                headers: { Accept: "text/vnd.turbo-stream.html" }
            })
            .then(response => response.text())
            .then(html => {
                frame.innerHTML = html
            })
        }
    }
}